import React, { useEffect, useState } from "react";
import NotificationCenter from "../../../components/Reseller/NotificationCenter";
import HelperClass from "./../../../config/helperClass";
import localization from "../../../localization/enUS";
import {
  getActivityLogs,
  getActivityLogsAgent,
  getActivityLogsClient,
  updateNotificationsStatus,
  updateAgentNotificationsStatus,
  updateClientNotificationsStatus,
  deleteNotifications,
  deleteAgentNotifications,
  deleteClientNotifications,
} from "./../../../config/api_calls";

const auth = new HelperClass();

export default function NotificationsPage(props) {
  const [activeTab, setActiveTab] = useState("admin");
  const [loading, setLoading] = useState(true);
  const [adminNotifications, setAdminNotifications] = useState([]);
  const [agentNotifications, setAgentNotifications] = useState([]);
  const [clientNotifications, setClientNotifications] = useState([]);

  const normalizeNotification = (notification) => ({
    id: notification.id,
    title: notification.log_title,
    description: notification.log_description,
    time: new Date(notification.date_added).toLocaleString(),
    is_read: Number(notification.is_read || 0),
    log_url: notification.log_url,
    log_type: notification.log_type,
    accountno: notification.accountno,
    agreement_accountno: notification.agreement_accountno,
    credit_app_id: notification.credit_app_id,
    rfq_accountno: notification.rfq_accountno,
    orderno: notification.orderno,
  });

  const updateTabState = (tabKey, updater) => {
    if (tabKey === "admin") {
      setAdminNotifications((prev) => updater(prev));
    } else if (tabKey === "agent") {
      setAgentNotifications((prev) => updater(prev));
    } else if (tabKey === "client") {
      setClientNotifications((prev) => updater(prev));
    }
  };

  const fetchNotifications = async () => {
    setLoading(true);

    try {
      const [adminRes, agentRes, clientRes] = await Promise.all([
        getActivityLogs(auth.getAccount(), auth.getToken()),
        getActivityLogsAgent(auth.getAccount(), auth.getToken()),
        getActivityLogsClient(auth.getAccount(), auth.getToken()),
      ]);

      const adminData =
        adminRes?.data?.status === 200 && Array.isArray(adminRes.data.data)
          ? adminRes.data.data.map(normalizeNotification)
          : [];

      const agentData =
        agentRes?.data?.status === 200 &&
        agentRes?.data?.data &&
        Array.isArray(agentRes.data.data.data)
          ? agentRes.data.data.data.map(normalizeNotification)
          : [];

      const clientData =
        clientRes?.data?.status === 200 &&
        clientRes?.data?.data &&
        Array.isArray(clientRes.data.data.data)
          ? clientRes.data.data.data.map(normalizeNotification)
          : [];

      setAdminNotifications(adminData);
      setAgentNotifications(agentData);
      setClientNotifications(clientData);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setAdminNotifications([]);
      setAgentNotifications([]);
      setClientNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const notificationType = props.props.match.params.notification_type;

    if (
      notificationType === "admin" ||
      notificationType === "agent" ||
      notificationType === "client"
    ) {
      setActiveTab(notificationType);
    } else {
      setActiveTab("admin");
    }

    fetchNotifications();
  }, [props.props.match.params.notification_type]);

  const applyBulkRead = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await updateNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      } else if (tabKey === "agent") {
        response = await updateAgentNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      } else {
        response = await updateClientNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.map((item) =>
            notificationIds.includes(item.id) ? { ...item, is_read: 1 } : item
          )
        );
        return true;
      }
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }

    return false;
  };

  const undoBulkRead = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await updateNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      } else if (tabKey === "agent") {
        response = await updateAgentNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      } else {
        response = await updateClientNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.map((item) =>
            notificationIds.includes(item.id) ? { ...item, is_read: 0 } : item
          )
        );
        return true;
      }
    } catch (error) {
      console.error("Error undoing notification update:", error);
    }

    return false;
  };

  const deleteBulkNotifications = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await deleteNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      } else if (tabKey === "agent") {
        response = await deleteAgentNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      } else {
        response = await deleteClientNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.filter((item) => !notificationIds.includes(item.id))
        );
        return true;
      }
    } catch (error) {
      console.error("Error deleting notifications:", error);
    }

    return false;
  };

  return (
    <div className="nk-content ">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block-head nk-block-head-sm">
              <div className="nk-block-between">
                <div className="nk-block-head-content">
                  <h3 className="nk-block-title page-title">
                    <em className="icon ni ni-list-round"></em> System Logs
                  </h3>
                </div>
              </div>
            </div>

            <div
              className="row g-gs notifications_table"
              style={{ clear: "both", marginTop: "0px" }}
            >
              <div className="col-lg-12">
                <div className="card card-bordered" style={{ clear: "both" }}>
                  <div className="card-inner">
                    <NotificationCenter
                      compact={false}
                      loading={loading}
                      title="Notifications"
                      activeTab={activeTab}
                      onTabChange={setActiveTab}
                      onBulkMarkRead={applyBulkRead}
                      onUndo={undoBulkRead}
                      onDelete={deleteBulkNotifications}
                      tabs={[
                        {
                          key: "admin",
                          label: "Admin",
                          items: adminNotifications,
                          emptyText: "No admin notifications yet.",
                        },
                        {
                          key: "agent",
                          label: localization.specificPortals.agentsLabel,
                          items: agentNotifications,
                          emptyText: `No ${localization.specificPortals.agentLabel.toLowerCase()} notifications yet.`,
                        },
                        {
                          key: "client",
                          label: "Clients",
                          items: clientNotifications,
                          emptyText: "No client notifications yet.",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
